import wixData from 'wix-data';

$w.onReady(function () {
    checkLangSettingsRepeater()

});

//..

export function checkLangSettingsRepeater() {

    let checkLangText = $w("#textNewsFirstRepeater").text

    if (checkLangText === "News") {
        console.log("EN")
        setDatasetEN()
    }

    if (checkLangText === "Actualités") {
        console.log("FR")
        setDatasetFR()
    }
    // set EN

    function setDatasetEN() {
        $w("#datasetActualites").setFilter(wixData.filter()
            .startsWith("langue", "E")
        );

        $w("#datasetAutresDocuments").setFilter(wixData.filter()
            .startsWith("langue", "A")
        );
    }

    // set FR

    function setDatasetFR() {
        $w("#datasetActualites").setFilter(wixData.filter()
            .startsWith("langue", "F")
        );

        $w("#datasetAutresDocuments").setFilter(wixData.filter()
            .startsWith("langue", "F")
        );
    }

}